"use client";

import dynamic from "next/dynamic";
import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { CYPH_TRACKER_SLUG } from "@/constants/cypherpunkTracker";
import { useNavMenu } from "@/contexts/NavMenuContext";
import DeferredMount from "@/components/ui/DeferredMount";
import MainContent from "@/components/layout/MainContent";

const NavMenuSidebar = dynamic(() => import("@/components/layout/NavMenuSidebar"), {
  ssr: false,
});
const Sidebar = dynamic(() => import("@/components/ui/Sidebar"), { ssr: false });

interface AppShellProps {
  children: ReactNode;
}

export default function AppShell({ children }: AppShellProps): React.ReactElement {
  const pathname = usePathname();
  const isHome = pathname === "/";
  const isCyphTracker = pathname === `/${CYPH_TRACKER_SLUG}`;
  const { isOpen: navMenuOpen } = useNavMenu();

  const sidebar = <Sidebar />;
  const sidebarSpacer = (
    <div
      className="hidden lg:block lg:sticky lg:top-0 z-50 lg:h-dvh w-[300px] shrink-0 border-r border-transparent"
      aria-hidden
    />
  );

  return (
    <div className="relative flex min-w-0 overflow-x-clip">
      {navMenuOpen ? <NavMenuSidebar /> : null}
      {!isHome ? (
        isCyphTracker ? (
          <DeferredMount timeoutMs={4500} fallback={sidebarSpacer}>
            {sidebar}
          </DeferredMount>
        ) : (
          sidebar
        )
      ) : null}
      <MainContent>{children}</MainContent>
    </div>
  );
}
